module.exports = __webpack_public_path__ + "static/media/img-app-feature-5.f1f63eb6.png";